import React from 'react';

import styles from './index.module.css';

// Glyphs are taken directly from the design. They are drawn in the source
// artboard's coordinate space (50x50 for steps, 46x46 for options) and fill the
// teal rounded container provided by CSS, so the white mark lands centered.
export function VideoIcon() {
  return (
    <svg
      width='100%'
      height='100%'
      viewBox='0 0 50 50'
      fill='#ffffff'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden='true'
    >
      <path d='M25 15.875C23.393 15.875 21.8221 16.3515 20.486 17.2443C19.1498 18.1371 18.1084 19.406 17.4935 20.8907C16.8785 22.3753 16.7176 24.009 17.0311 25.5851C17.3446 27.1612 18.1185 28.6089 19.2548 29.7452C20.3911 30.8815 21.8388 31.6554 23.4149 31.9689C24.991 32.2824 26.6247 32.1215 28.1093 31.5065C29.594 30.8916 30.8629 29.8502 31.7557 28.514C32.6485 27.1779 33.125 25.607 33.125 24C33.1227 21.8458 32.266 19.7805 30.7427 18.2573C29.2195 16.734 27.1542 15.8773 25 15.875ZM28.168 24.5141L24.1055 27.3266C24.0117 27.3914 23.9019 27.4294 23.7881 27.4363C23.6743 27.4433 23.5608 27.419 23.4598 27.366C23.3588 27.3131 23.2742 27.2335 23.2152 27.1359C23.1562 27.0384 23.125 26.9265 23.125 26.8125V21.1875C23.125 21.0735 23.1562 20.9616 23.2152 20.8641C23.2742 20.7665 23.3588 20.6869 23.4598 20.634C23.5608 20.581 23.6743 20.5567 23.7881 20.5637C23.9019 20.5706 24.0117 20.6086 24.1055 20.6734L28.168 23.4859C28.2511 23.5434 28.3191 23.6202 28.366 23.7098C28.413 23.7993 28.4375 23.8989 28.4375 24C28.4375 24.1011 28.413 24.2007 28.366 24.2902C28.3191 24.3798 28.2511 24.4566 28.168 24.5141Z' />
    </svg>
  );
}

export function PhoneIcon() {
  return (
    <svg
      width='100%'
      height='100%'
      viewBox='0 0 50 50'
      fill='#ffffff'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden='true'
    >
      <path d='M26.4328 22.5672C26.3747 22.5092 26.3286 22.4402 26.2972 22.3644C26.2657 22.2885 26.2495 22.2072 26.2495 22.125C26.2495 22.0429 26.2657 21.9616 26.2972 21.8857C26.3286 21.8098 26.3747 21.7409 26.4328 21.6828L29.1164 19H27.5C27.3342 19 27.1753 18.9342 27.0581 18.817C26.9409 18.6998 26.875 18.5408 26.875 18.375C26.875 18.2093 26.9409 18.0503 27.0581 17.9331C27.1753 17.8159 27.3342 17.75 27.5 17.75H30.625C30.7908 17.75 30.9497 17.8159 31.0669 17.9331C31.1842 18.0503 31.25 18.2093 31.25 18.375V21.5C31.25 21.6658 31.1842 21.8248 31.0669 21.942C30.9497 22.0592 30.7908 22.125 30.625 22.125C30.4592 22.125 30.3003 22.0592 30.1831 21.942C30.0659 21.8248 30 21.6658 30 21.5V19.8836L27.3172 22.5672C27.2591 22.6253 27.1902 22.6714 27.1143 22.7029C27.0385 22.7343 26.9571 22.7505 26.875 22.7505C26.7929 22.7505 26.7115 22.7343 26.6357 22.7029C26.5598 22.6714 26.4909 22.6253 26.4328 22.5672ZM31.7453 27.0047L28.0649 25.3555L28.0547 25.3508C27.8636 25.2691 27.6552 25.2363 27.4483 25.2554C27.2413 25.2745 27.0424 25.3449 26.8695 25.4602C26.8492 25.4736 26.8296 25.4882 26.8109 25.5039L24.9117 27.125C23.707 26.5399 22.4633 25.3055 21.8781 24.1164L23.5016 22.186C23.5172 22.1664 23.532 22.1469 23.5461 22.1258C23.6589 21.9534 23.7274 21.7557 23.7454 21.5505C23.7634 21.3452 23.7303 21.1387 23.6492 20.9492V20.9399L21.9953 17.2532C21.8881 17.0057 21.7037 16.7996 21.4697 16.6655C21.2357 16.5315 20.9646 16.4767 20.6969 16.5094C19.6383 16.6487 18.6666 17.1686 17.9632 17.972C17.2599 18.7754 16.8731 19.8073 16.875 20.875C16.875 27.0781 21.9219 32.125 28.125 32.125C29.1927 32.1269 30.2247 31.7401 31.0281 31.0368C31.8314 30.3335 32.3513 29.3618 32.4906 28.3032C32.5234 28.0355 32.4687 27.7645 32.3348 27.5305C32.2009 27.2965 31.995 27.1121 31.7477 27.0047H31.7453Z' />
    </svg>
  );
}

export function LockIcon() {
  return (
    <svg
      width='100%'
      height='100%'
      viewBox='0 0 50 50'
      fill='#ffffff'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden='true'
    >
      <path d='M31.25 20.25H28.75V18.375C28.75 17.3804 28.3549 16.4266 27.6517 15.7233C26.9484 15.0201 25.9946 14.625 25 14.625C24.0054 14.625 23.0516 15.0201 22.3483 15.7233C21.6451 16.4266 21.25 17.3804 21.25 18.375V20.25H18.75C18.4185 20.25 18.1005 20.3817 17.8661 20.6161C17.6317 20.8505 17.5 21.1685 17.5 21.5V30.25C17.5 30.5815 17.6317 30.8995 17.8661 31.1339C18.1005 31.3683 18.4185 31.5 18.75 31.5H31.25C31.5815 31.5 31.8995 31.3683 32.1339 31.1339C32.3683 30.8995 32.5 30.5815 32.5 30.25V21.5C32.5 21.1685 32.3683 20.8505 32.1339 20.6161C31.8995 20.3817 31.5815 20.25 31.25 20.25ZM25 26.8125C24.8146 26.8125 24.6333 26.7575 24.4792 26.6545C24.325 26.5515 24.2048 26.4051 24.1339 26.2338C24.0629 26.0625 24.0443 25.874 24.0805 25.6921C24.1167 25.5102 24.206 25.3432 24.3371 25.2121C24.4682 25.081 24.6352 24.9917 24.8171 24.9555C24.999 24.9193 25.1875 24.9379 25.3588 25.0089C25.5301 25.0798 25.6765 25.2 25.7795 25.3542C25.8825 25.5083 25.9375 25.6896 25.9375 25.875C25.9375 26.1236 25.8387 26.3621 25.6629 26.5379C25.4871 26.7137 25.2486 26.8125 25 26.8125ZM27.5 20.25H22.5V18.375C22.5 17.712 22.7634 17.0761 23.2322 16.6072C23.7011 16.1384 24.337 15.875 25 15.875C25.663 15.875 26.2989 16.1384 26.7678 16.6072C27.2366 17.0761 27.5 17.712 27.5 18.375V20.25Z' />
    </svg>
  );
}

export function CheckIcon() {
  return (
    <svg
      width='100%'
      height='100%'
      viewBox='0 0 50 50'
      fill='#ffffff'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden='true'
    >
      <path d='M25 15.875C23.393 15.875 21.8221 16.3515 20.486 17.2443C19.1498 18.1371 18.1084 19.406 17.4935 20.8907C16.8785 22.3753 16.7176 24.009 17.0311 25.5851C17.3446 27.1612 18.1185 28.6089 19.2548 29.7452C20.3911 30.8815 21.8388 31.6554 23.4149 31.9689C24.991 32.2824 26.6247 32.1215 28.1093 31.5065C29.594 30.8916 30.8629 29.8502 31.7557 28.514C32.6485 27.1779 33.125 25.607 33.125 24C33.1227 21.8458 32.266 19.7805 30.7427 18.2573C29.2195 16.734 27.1542 15.8773 25 15.875ZM28.5672 22.5672L24.1922 26.9422C24.1341 27.0003 24.0652 27.0464 23.9893 27.0779C23.9135 27.1093 23.8321 27.1255 23.75 27.1255C23.6679 27.1255 23.5865 27.1093 23.5107 27.0779C23.4348 27.0464 23.3659 27.0003 23.3078 26.9422L21.4328 25.0672C21.3155 24.9499 21.2497 24.7909 21.2497 24.625C21.2497 24.4591 21.3155 24.3001 21.4328 24.1828C21.5501 24.0655 21.7092 23.9997 21.875 23.9997C22.0409 23.9997 22.1999 24.0655 22.3172 24.1828L23.75 25.6164L27.6828 21.6828C27.7409 21.6247 27.8098 21.5787 27.8857 21.5473C27.9616 21.5158 28.0429 21.4997 28.125 21.4997C28.2071 21.4997 28.2884 21.5158 28.3643 21.5473C28.4402 21.5787 28.5091 21.6247 28.5672 21.6828C28.6253 21.7409 28.6713 21.8098 28.7027 21.8857C28.7342 21.9616 28.7504 22.0429 28.7504 22.125C28.7504 22.2071 28.7342 22.2884 28.7027 22.3643C28.6713 22.4402 28.6253 22.5091 28.5672 22.5672Z' />
    </svg>
  );
}

export function PhoneCallIcon() {
  return (
    <svg
      width='100%'
      height='100%'
      viewBox='0 0 46 46'
      fill='#ffffff'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden='true'
    >
      <path d='M24.144 16.2294C24.1631 16.158 24.1961 16.0911 24.241 16.0325C24.286 15.9738 24.3421 15.9246 24.4061 15.8877C24.4701 15.8507 24.5407 15.8267 24.614 15.8171C24.6872 15.8074 24.7617 15.8123 24.8331 15.8315C25.8758 16.1035 26.8272 16.6487 27.5893 17.4107C28.3513 18.1727 28.8964 19.1242 29.1685 20.1669C29.1877 20.2383 29.1925 20.3128 29.1829 20.386C29.1733 20.4593 29.1493 20.5299 29.1123 20.5939C29.0753 20.6579 29.0261 20.714 28.9675 20.759C28.9089 20.8039 28.8419 20.8369 28.7706 20.856C28.723 20.8685 28.6741 20.8749 28.625 20.875C28.5011 20.875 28.3807 20.8342 28.2825 20.7588C28.1842 20.6834 28.1135 20.5777 28.0815 20.458C27.8597 19.6066 27.4149 18.8298 26.7928 18.2076C26.1707 17.5855 25.394 17.1405 24.5427 16.9185C24.4712 16.8995 24.4042 16.8666 24.3455 16.8216C24.2868 16.7767 24.2375 16.7206 24.2005 16.6566C24.1634 16.5926 24.1394 16.5219 24.1297 16.4486C24.12 16.3753 24.1249 16.3009 24.144 16.2294ZM23.9802 19.1685C24.9498 19.4272 25.5727 20.0509 25.8315 21.0205C25.8635 21.1402 25.9342 21.2459 26.0325 21.3213C26.1307 21.3967 26.2511 21.4375 26.375 21.4375C26.4241 21.4374 26.473 21.431 26.5206 21.4185C26.5919 21.3994 26.6589 21.3664 26.7175 21.3215C26.7761 21.2765 26.8253 21.2204 26.8623 21.1564C26.8993 21.0924 26.9233 21.0218 26.9329 20.9485C26.9425 20.8753 26.9377 20.8008 26.9185 20.7294C26.5585 19.3822 25.6177 18.4415 24.2706 18.0815C24.1264 18.043 23.9729 18.0633 23.8437 18.138C23.7145 18.2127 23.6204 18.3356 23.5818 18.4798C23.5433 18.6239 23.5637 18.7775 23.6384 18.9066C23.7131 19.0358 23.836 19.13 23.9802 19.1685ZM29.0729 24.7042L25.7605 23.2199L25.7513 23.2157C25.5794 23.1421 25.3918 23.1126 25.2055 23.1298C25.0193 23.147 24.8403 23.2103 24.6847 23.3141C24.6664 23.3262 24.6488 23.3394 24.632 23.3535L22.9206 24.8125C21.8363 24.2858 20.717 23.1749 20.1903 22.1047L21.6514 20.3673C21.6655 20.3497 21.6788 20.3322 21.6915 20.3132C21.793 20.158 21.8547 19.9801 21.8708 19.7954C21.887 19.6106 21.8573 19.4248 21.7843 19.2543V19.2458L20.2958 15.9278C20.1993 15.7051 20.0333 15.5196 19.8227 15.3989C19.6121 15.2783 19.3681 15.229 19.1272 15.2584C18.1744 15.3838 17.2999 15.8517 16.6669 16.5747C16.0339 17.2978 15.6858 18.2265 15.6875 19.1875C15.6875 24.7703 20.2297 29.3125 25.8125 29.3125C26.7735 29.3142 27.7022 28.9661 28.4253 28.3331C29.1483 27.7001 29.6162 26.8255 29.7416 25.8728C29.771 25.6319 29.7219 25.388 29.6013 25.1774C29.4808 24.9668 29.2955 24.8008 29.0729 24.7042Z' />
    </svg>
  );
}

export function CalendarIcon() {
  return (
    <svg
      width='100%'
      height='100%'
      viewBox='0 0 46 46'
      fill='#ffffff'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden='true'
    >
      <path d='M28.625 15.25H26.9375V14.6875C26.9375 14.5383 26.8782 14.3952 26.7727 14.2898C26.6673 14.1843 26.5242 14.125 26.375 14.125C26.2258 14.125 26.0827 14.1843 25.9773 14.2898C25.8718 14.3952 25.8125 14.5383 25.8125 14.6875V15.25H20.1875V14.6875C20.1875 14.5383 20.1282 14.3952 20.0227 14.2898C19.9173 14.1843 19.7742 14.125 19.625 14.125C19.4758 14.125 19.3327 14.1843 19.2273 14.2898C19.1218 14.3952 19.0625 14.5383 19.0625 14.6875V15.25H17.375C17.0766 15.25 16.7905 15.3685 16.5795 15.5795C16.3685 15.7905 16.25 16.0766 16.25 16.375V27.625C16.25 27.9234 16.3685 28.2095 16.5795 28.4205C16.7905 28.6315 17.0766 28.75 17.375 28.75H28.625C28.9234 28.75 29.2095 28.6315 29.4205 28.4205C29.6315 28.2095 29.75 27.9234 29.75 27.625V16.375C29.75 16.0766 29.6315 15.7905 29.4205 15.5795C29.2095 15.3685 28.9234 15.25 28.625 15.25ZM28.625 18.625H17.375V16.375H19.0625V16.9375C19.0625 17.0867 19.1218 17.2298 19.2273 17.3352C19.3327 17.4407 19.4758 17.5 19.625 17.5C19.7742 17.5 19.9173 17.4407 20.0227 17.3352C20.1282 17.2298 20.1875 17.0867 20.1875 16.9375V16.375H25.8125V16.9375C25.8125 17.0867 25.8718 17.2298 25.9773 17.3352C26.0827 17.4407 26.2258 17.5 26.375 17.5C26.5242 17.5 26.6673 17.4407 26.7727 17.3352C26.8782 17.2298 26.9375 17.0867 26.9375 16.9375V16.375H28.625V18.625Z' />
    </svg>
  );
}

export function WarningIcon() {
  return (
    <svg
      width='13'
      height='13'
      viewBox='0 0 24 24'
      fill='#f2c94c'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003ZM12 8.25a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75Zm0 8.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z'
      />
    </svg>
  );
}

export function ChevronDownIcon() {
  return (
    <svg width='12' height='12' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' aria-hidden='true'>
      <path d='M4 6L8 10L12 6' stroke='currentColor' strokeWidth='1.8' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
}

export function CloseIcon() {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' aria-hidden='true'>
      <path d='M3 3L13 13M13 3L3 13' stroke='currentColor' strokeWidth='1.8' strokeLinecap='round' />
    </svg>
  );
}

export function StepCard({
  variant = 'aqua',
  icon,
  label,
  title,
  description,
  aside,
  callout,
  footerTitle,
  footerDescription,
  subFooterTitle,
  subFooterDescription,
}) {
  const variantClass = {
    aqua: styles.card_aqua,
    white: styles.card_white,
    final: styles.card_final,
  }[variant];

  return (
    <section className={`${styles.card} ${variantClass}`}>
      <div className={styles.card_inner}>
        <div className={styles.card_lead}>
          <span className={styles.step_icon}>{icon}</span>
          <div className={styles.card_lead_text}>
            <p className={styles.step_label}>{label}</p>
            <h3 className={styles.step_title}>{title}</h3>
            <p className={styles.step_desc}>{description}</p>
            <div className={styles.empty_space}></div>
            <h3 className={styles.step_title}>{footerTitle}</h3>
            <p className={styles.step_desc}>{footerDescription}</p>
            <div className={styles.empty_space}></div>
            <h3 className={styles.step_title}>{subFooterTitle}</h3>
            <p className={styles.step_desc}>{subFooterDescription}</p>
          </div>
        </div>
        {aside && <div className={styles.card_aside}>{aside}</div>}
      </div>
      {callout && <div className={styles.card_callout_footer}>{callout}</div>}
    </section>
  );
}

export function BulletList({ items }) {
  return (
    <ul className={styles.bullets}>
      {items.map((item, index) => (
        <li className={styles.bullet} key={index}>
          <span className={styles.bullet_dot} aria-hidden='true' />
          <span className={styles.bullet_text}>{item}</span>
        </li>
      ))}
    </ul>
  );
}

export function NumberedList({ items }) {
  return (
    <ol className={styles.ol}>
      {items.map((item, index) => (
        <li className={styles.ol_item} key={index}>
          <span className={styles.ol_num}>{index + 1}</span>
          <span className={styles.ol_text}>{item}</span>
        </li>
      ))}
    </ol>
  );
}

export function Callout({ title, body }) {
  return (
    <div className={styles.callout}>
      <p className={styles.callout_eyebrow}>
        <span className={styles.callout_icon}>
          <WarningIcon />
        </span>
        {title}
      </p>
      <p className={styles.callout_body}>{body}</p>
    </div>
  );
}

export function Connector({ label }) {
  return (
    <div className={styles.connector}>
      <span className={styles.connector_dot}>
        <ChevronDownIcon />
      </span>
      <span className={styles.connector_chip}>{label}</span>
    </div>
  );
}
